import _ from 'lodash'
import $ from 'jquery'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import ComponentVue from './Component'
import InteractableComponent from './InteractableComponent'
import { ImageData } from '../../store/editor/components/state'
import { Actions } from '../../store/editor/components/helpers'
import { CONTENTS_CONTAINER_SELECTOR } from '../constants/ContainerSelector'
import ChamomileUrl from '../../misc/chamomile-url'

type MenuMode = 'top' | 'link'

@Component
export default class ImageVue extends ComponentVue<ImageData> {
  private interactable: InteractableComponent
  private menuMode: MenuMode = 'top'
  private editingLinkUrl: string = ''

  get chamomileUrl(): ChamomileUrl | undefined {
    return ChamomileUrl.parse(this.editingLinkUrl)
  }

  get isUrlValid(): boolean {
    return !!this.chamomileUrl
  }

  get imageUrl(): string | undefined {
    return this.componentData._dataUrl || ''
  }

  get linkUrl(): string | undefined {
    return this.componentData.linkUrl || ''
  }

  set linkUrl(linkUrl: string | undefined) {
    const data = this.componentData
    this.save(Object.assign({}, data, {
      linkUrl: linkUrl || ''
    }))
  }

  mounted(): void {
    this.enableFocus()
    this.interactable = new InteractableComponent(this.$el, this.$store)
    this.interactable.draggable({
      handle: '.image-content__handle',
      extraTransform: 'scale(.7)'
    })
    this.interactable.droppable()
      .onDropTo((event) => {
        Actions.move(this.$store, {
          component: event.dropping,
          destination: this.componentData,
          direction: event.direction
        })
      })
      .on('down', (event) => {
        this.forceFocus()
      })
  }

  destroyed(): void {
    this.interactable.destroy()
  }

  @Watch('hasFocus')
  onFocusChanged(): void {
    if (!this.hasFocus) {
      this.menuMode = 'top'
    } else {
      this.adjustMenuOffset()
    }
  }

  openMenuTop(): void {
    this.changeMenuMode('top')
  }

  openMenuLink(): void {
    this.editingLinkUrl = this.linkUrl
    this.changeMenuMode('link')
    this.$nextTick(() => {
      const input = (<HTMLInputElement>this.$refs.linkUrl)
      input.select()
    })
  }

  updateLink(): void {
    if (this.isUrlValid) {
      this.linkUrl = this.editingLinkUrl ? this.editingLinkUrl : ''
      this.openMenuTop()
    }
  }

  removeLink(): void {
    this.linkUrl = ''
  }

  changeMenuMode(mode: MenuMode): void {
    this.menuMode = mode
    this.adjustMenuOffset()
  }

  adjustMenuOffset(): void {
    this.$nextTick(() => {
      // メニューが画面端に寄り過ぎていたら、位置を調整する
      const menu = $(this.$el).find('.menu-container').get(0)
      menu.style.cssText = ''
      const menuRight = menu.getBoundingClientRect().right
      const containerRight = $(CONTENTS_CONTAINER_SELECTOR).get(0).getBoundingClientRect().right
      const diff = menuRight - containerRight
      if (diff > 0) {
        menu.style.cssText = 'left: auto; right: 0;'
      } else {
        menu.style.cssText = ''
      }
    })
  }

  onFileUploaded(event: Event): void {
    const input: HTMLInputElement = <HTMLInputElement>event.target
    const file = _.head(input.files)
    if (file) {
      this.replaceImage(file)
    }
    input.value = ''
  }

  async replaceImage(file: File): Promise<void> {
    const source = (await Actions.uploadImages(this.$store, [file]))[0]
    const data = await Actions.createImageData(this.$store, source)
    this.save(Object.assign({}, this.componentData, <ImageData>{
      fileName: data.fileName,
      _dataUrl: data._dataUrl
    }))
  }
}
